function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M15.2 13.5L13.7 11C14.5 9.9 15 8.5 15 7C15 3.1 11.9 0 8 0C4.1 0 0.999995 3.1 0.999995 7C0.999995 8.5 1.49999 9.9 2.29999 11L0.799995 13.5C0.499995 14.1 0.499995 14.7 0.899995 15.3C1.3 15.8 1.89999 16.1 2.49999 16L8 15L13.5 16C13.6 16 13.7 16 13.8 16C14.3 16 14.8 15.7 15.1 15.3C15.6 14.8 15.6 14.1 15.2 13.5ZM8 10C6.3 10 5 8.7 5 7C5 5.3 6.3 4 8 4C9.7 4 11 5.3 11 7C11 8.7 9.7 10 8 10Z",
  fill: "#002A95"
});

var SvgVideoCalls = function SvgVideoCalls(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgVideoCalls, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/VideoCalls.d52ac591.svg";
export { ForwardRef as ReactComponent };